import { Injectable } from "@angular/core";
import { Action, createSelector, State, StateContext } from "@ngxs/store";
import { append, patch, updateItem } from "@ngxs/store/operators";

import { AddDynamicAsset } from "./dynamic-asset.actions";

interface Asset {
	name: string;
	path: string;
}

export interface DynamicAssetStateModel {
	assets: Asset[];
}

@State<DynamicAssetStateModel>({
	name: "dynamicassets",
	defaults: {
		assets: [],
	},
})
@Injectable()
export class DynamicAssetState {
	static assetPath(name: string) {
		return createSelector([DynamicAssetState], (state: DynamicAssetStateModel) => {
			const asset = state.assets.find((a) => a.name === name);
			const path = asset ? asset.path : "";
			return `${path}?cacheBuster=${Date.now()}`;
		});
	}

	@Action(AddDynamicAsset)
	public setGeneralConfiguration(
		ctx: StateContext<DynamicAssetStateModel>,
		action: AddDynamicAsset,
	) {
		const knownAsset = ctx.getState().assets.find((a) => a.name === action.name);
		if (knownAsset) {
			ctx.setState(
				patch({
					assets: updateItem<Asset>(
						(a) => a?.name === action.name,
						patch({
							path: action.path,
						}),
					),
				}),
			);
		} else {
			ctx.setState(
				patch({
					assets: append([
						{
							name: action.name,
							path: action.path,
						},
					]),
				}),
			);
		}
	}
}
